import PaperIcon from '@assets/images/paper.svg?react'
import PointedShieldIcon from '@assets/images/pointed-shield.svg?react'

import { AssociatedIssuesTable } from '@ui/drawer/common/AssociatedIssuesTable'
import { SectionHeader } from '@ui/drawer/common/SectionHeader'

import {
    Body,
    DetailsSection,
    IssuesSection,
    IssuesTableHost,
    SectionDivider,
    Wrapper,
} from './technologyDetails.styles'
import { TechnologyInfo } from './technologyInfo'
import { useTechnologyDetails } from './useTechnologyDetails'

const TechnologyDetails = () => {
    const { currentTechnology, enrichedTechnologyIssues } =
        useTechnologyDetails()

    if (!currentTechnology) return null

    return (
        <Wrapper>
            <Body>
                <DetailsSection>
                    <SectionHeader
                        icon={<PaperIcon />}
                        title="Details"
                        dataTestId="details-section"
                    />
                    <TechnologyInfo technology={currentTechnology} />
                </DetailsSection>
                <SectionDivider />
                <IssuesSection>
                    <SectionHeader
                        icon={<PointedShieldIcon />}
                        title="Open issues"
                        count={enrichedTechnologyIssues.length}
                        dataTestId="associated-issues-section"
                    />
                    <IssuesTableHost>
                        <AssociatedIssuesTable
                            issues={enrichedTechnologyIssues}
                            dataTestId="associated-issues-table"
                            origin="technology-drawer"
                        />
                    </IssuesTableHost>
                </IssuesSection>
            </Body>
        </Wrapper>
    )
}

export default TechnologyDetails
